import SideNav from "./sidenav";
import React, { useState, useEffect, Component } from "react";
import PaymentBg from "../images/payments.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Download from "../images/downloadicon.png";
import Check from "../images/check.png";
import "./faq.css";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});


const Faq = () => {

   window.scrollTo(0, 0)

   
    const [active, setActive] = useState("General FAQs");

        const [general, setGeneral] = useState([])
        const [contribution, setContribution] = useState([])
        const [death, setDeath] = useState([])
        const [mortgage, setMortgage] = useState([])
        const [micropension, setMicropension] = useState([])
        const [withdrawal, setWithdrawal] = useState([])
        const [investment, setInvestment] = useState([])
        const [multifund, setMultifund] = useState([])


        useEffect( () => {
               AOS.init({
                  offset: 0,
                  duration: 1000,
                  once: true
           });
                            
                                
           }, [])

useEffect( () => {
      
      client
        .query({
          query: gql`
        query NewQuery {
pages(first:100) {
    edges {
      node {
        faqs {
          contribution {
            answer
            question
            fieldGroupName
          }
          death {
            answer
            question
            fieldGroupName
          }
          general {
            answer
            question
            fieldGroupName
          }
          investment {
            answer
            question
            fieldGroupName
          }
          micropensions {
            answer
            question
            fieldGroupName
          }
          mortgages {
            answer
            question
            fieldGroupName
          }
          multifund {
            answer
            question
            fieldGroupName
          }
          withdrawal {
            answer
            question
            fieldGroupName
          }
        }
      }
    }
  }
      }
          `,
        })
        .then((result) => {
      
           console.log(result)

            setGeneral(result.data.pages.edges[11].node.faqs.general)
            setContribution(result.data.pages.edges[11].node.faqs.contribution)
            setMultifund(result.data.pages.edges[11].node.faqs.multifund)
            setMortgage(result.data.pages.edges[11].node.faqs.mortgages)
            setDeath(result.data.pages.edges[11].node.faqs.death)
            setMicropension(result.data.pages.edges[11].node.faqs.micropensions)
            setWithdrawal(result.data.pages.edges[11].node.faqs.withdrawal)
            setInvestment(result.data.pages.edges[11].node.faqs.investment)
      
        });
      
      }, [])  
   


    function switchFaq(e){ 
    let value= e.target.value
   // alert(value)
    setActive(value)
  }


            let generalDisplay
            let contributionDisplay
            let withdrawalDisplay
            let investmentDisplay
            let multifundDisplay
            let micropensionDisplay
            let deathDisplay
            let mortgageDisplay
                          
                          
                        



  const menuItems = [
    "General FAQs",
    "Contribution FAQs",
    "Withdraw and Retirement FAQs",
    "Death Benefit FAQs",
    "Investment Terms on The Statement FAQs",
    "MultiFund Structure FAQs",
    "Residential Mortgage FAQs",
    "Micropension FAQs",
  ];


  return (
    <>
      <div
        id="faq-types-section"
        class="containeer d-flex align-items-start   mt-4"
        style={{ backgroundColor: "none" }}
      >
        <SideNav items={menuItems} activeItem={active} onSelect={setActive} types={false} funds={false} />


        <div className="flex-1 p-6 full-width"  data-aos="fade-up" data-aos-delay="200">
     <h6 className="dark-history d-block d-md-none pt-3 pb-3">Filter</h6>
      <select className="form-select faq-select d-block d-md-none" aria-label="Default select example" onChange={switchFaq}>
       <option value="General FAQs" selected> General FAQs </option>
        <option value="Contribution FAQs"> Contribution FAQs </option>
        <option value="Withdraw and Retirement FAQs"> Withdraw and Retirement FAQs </option>
          <option value="Death Benefit FAQs"> Death Benefit FAQs </option>
          <option value="Investment Terms on The Statement FAQs"> Investment Terms on The Statement FAQs </option>
          <option value="MultiFund Structure FAQs"> MultiFund Structure FAQs </option>
          <option value="Residential Mortgage FAQs">Residential Mortgage FAQs </option>
                    <option value="Micropension FAQs"> Micropension FAQs </option>
              </select>
          {active === "General FAQs" && (


            general.map((question, i) => 
                    i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Answers to the most common questions about our services, processes, and platform.
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content"  data-aos="fade-up" data-aos-delay="200">
              
                     <div class="accordion mt-3" id="accordionExample">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>
                                  
               )
           )}
          {active === "Contribution FAQs" && (
              contribution.map((question, i) => 
                    
          i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
              Learn how pension contributions are made, tracked, and corrected
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content"  data-aos="fade-up" data-aos-delay="200">
              
                     <div class="accordion mt-3" id="accordionExample">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

              )
          )}
          {active === "Withdraw and Retirement FAQs" && (
                            withdrawal.map((question, i) => 
                    
                i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Answers on eligibility, timing, and how retirement withdrawals work.
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content"  data-aos="fade-up" data-aos-delay="200">
              
                     <div class="accordion mt-3" id="accordionExample">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                                  
               )
          )}
          {active === "Death Benefit FAQs" && (
                           death.map((question, i) => 
                    
                 i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Find out what happens to RSA funds when a contributor passes away.
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content">
              
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                                  
               )
          )}
          {active === "Investment Terms on The Statement FAQs" && (
             investment.map((question, i) => 
                    
                i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Clarifications on the terms and figures in your pension statement
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content">
              
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                                  
               )
          )}
          {active === "MultiFund Structure FAQs" && (
                            multifund.map((question, i) => 
                    
           i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Common questions about how fund types work and who they apply to
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content">
              
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                                  
               )
          )}
          {active === "Residential Mortgage FAQs" && (
                           mortgage.map((question, i) => 
                    
                 i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Learn how RSA holders can use their savings for mortgage equity.
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content">
              
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                                  
               )
          )}
          {active === "Micropension FAQs" && (
             micropension.map((question, i) => 
                    
              i === 0 ?
              <div className="faq-type-content">
                    <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">{question.fieldGroupName} FAQs</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Helpful responses for self-employed or informal sector contributors.
              </p>
                <hr className="btm-bdr-rma" />
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                 :

                     <div className="faq-type-content">
              
                     <div class="accordion mt-3" id="accordionExample"  data-aos="fade-up" data-aos-delay="200">
                   <div class="accordion-item">
                 <h2 class="accordion-header">
                 <button class="accordion-button faqHeading" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {question.question}
                 </button>
                </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body faqBody">
                  <p className="grey-p-faq"> {question.answer} </p>    
                     </div>
             </div>
             </div>
                 </div>
                 </div>

                                  
               )
          )}
        </div>
      </div>
       <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default Faq;
